import React from "react";
import "../styles/About.css";
import FadeInSection from "./FadeInSection";

class About extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const one = (
      <p>
        I am a <b>Software Engineer</b> currently in my second year pursuing {" "}
        <b>Bachelor of Technology</b> in <b>Computer Science</b> at{" "}
        <a href="https://iiitdm.ac.in/">IIITDM Kancheepuram</a>.
      </p>
    );
    const two = (
      <p>
        Outside of academics, I am passionate about exploring the latest{" "}
        <b>scientific advancements</b>. I play the <b>guitar</b> and <b>piano</b>,{" "}
        <b>sketch</b>, enjoy playing <b>basketball</b>, and love <b>reading</b>.
     </p>
    );


    const tech_stack = [
      "Typescript",
      "Python",
      "React.js",
      "Javascript ES6+",
      "C++",
      "Node.js",
      "Next.js",
      "Express.js"
    ];

    return (
      <div id="about">
        <FadeInSection>
          <div className="section-header ">
            <span className="section-title">/ about me</span>
          </div>
          <div className="about-content">
            <div className="about-description">
              {[one]}
              {"Here are some technologies I have been working with:"}
              <ul className="tech-stack">
                {tech_stack.map(function (tech_item, i) {
                  return (
                    <FadeInSection delay={`${i + 1}00ms`}>
                      <li>{tech_item}</li>
                    </FadeInSection>
                  );
                })}
              </ul>
              {[two]}
            </div>
            <div className="about-image">
              <img alt="Anvita Prasad" src={"/assets/me2.jpg"} />
            </div>
          </div>
        </FadeInSection>
      </div>
    );
  }
}

export default About;
